import storage from '@/libs/storage';
import config from '@/config';
import Vue from 'vue';
const vm = new Vue();

import { getUrlParam } from '@/utils';

const WXPUB_APPID = 'wxf76bf386d0fdcc0e';
const HLL_TICKET_EXPIRE = 1 * 60 * 60 * 1000; // 一小时

function wxAuth(cb) {
  var hllTicket = getUrlParam('hll_ticket') || getQueryString('hll_ticket');
  if (hllTicket) {
    storage.set('hll_ticket_', hllTicket, HLL_TICKET_EXPIRE);
    return cb && cb();
  }
  if (getHllTicket()) {
    return cb && cb();
  }
  //授权失败
  if (getUrlParam('wx_token_fail')) {
    vm.$hll.toast('微信授权失败，请关掉页面重新进入');
    throw new Error();
  }
  toWxAuth();
}

/**
 * 跳转去微信授权
 * @param referer
 */
// third_app/wechat/welfare_app/v1/wx_auth
function toWxAuth() {
  let url = location.href;
  location.href = `${
    config.baseURL
  }/third_app/wechat/xl_subscription_app/wx_auth?redirect_uri=${encodeURIComponent(
    url
  )}&appid=${WXPUB_APPID}`;
}

function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  if (window.location.hash.indexOf('?') < 0) {
    return null;
  }
  let r = window.location.hash.split('?')[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

function getHllTicket() {
  return storage.get('hll_ticket_');
}

export { wxAuth, getHllTicket };
